import { ItemInterface } from "../interfaces/ItemInterface";

/**
 * Items a shipment keeps when releasing its promotion: the base line plus
 * mandatory lines, explicitly excluding coupon lines.
 *
 * The base item is ALWAYS kept, even if coupon metadata rides on it —
 * updateShipment derives mainItem/RateTier from it and asserts it exists.
 *
 * The couponID exclusion is defense in depth at the payload level:
 * updateShipment itself only serializes non-mandatory, non-base items into
 * ShipmentItem, so the wire body of the release PUT is already coupon-free.
 * Filtering here keeps the client-side intent explicit (getShipment maps
 * EVERY item of a saved guide as mandatory:true, so a resumed guide's coupon
 * line would otherwise ride along in the items array) instead of relying on
 * updateShipment's internal filter.
 */
export const getPromotionReleaseBaseItems = (
  items: ItemInterface[]
): ItemInterface[] =>
  items.filter(
    (item) => item.isItemBase || (item.mandatory && !item.couponID)
  );
